import { render, staticRenderFns } from "./EmailSignatures.vue?vue&type=template&id=04b8ebbf&scoped=true&"
import script from "./EmailSignatures.vue?vue&type=script&lang=ts&"
export * from "./EmailSignatures.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/helpdesk/email-templates.css?vue&type=style&index=0&id=04b8ebbf&prod&scoped=true&lang=css&"
import style1 from "./EmailSignatures.vue?vue&type=style&index=1&id=04b8ebbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8ebbf",
  null
  
)

export default component.exports